import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as DeviceListActions from './device-list.actions';
import { DeviceService } from 'src/app/services/device.service';


@Injectable()
export class DeviceListEffects {
    getInstalledViews$ = createEffect(() => this.actions$.pipe(
        ofType(DeviceListActions.getInstalledViews),
        switchMap((action) => this.deviceService.getInstalledViews(action.paging, action.filter, null, action.siteId).pipe(
            map((resp) => {
                if (resp.Success) {
                    return DeviceListActions.getInstalledViewsSuccess({ paging: resp.Data.Paging, installedViews: resp.Data.Items });
                } else {
                    return DeviceListActions.getInstalledViewsFailed({ errorMessage: resp.ErrorMessage });
                }
            }),
            catchError(error => {
                console.error(error);
                return of(DeviceListActions.getInstalledViewsFailed({ errorMessage: error.message }));
            })
        ))
    ));

    constructor(
        private actions$: Actions,
        private deviceService: DeviceService,
    ) {}
}

